import React, { useState, useEffect } from 'react';
import './profile.css';
import Spinner from '../Loading/spiner'; 
import usuario from '../../Assets/usuario.png';
import { useAuth } from '../../Components/Contexts/authContext'; 
import Menu from '../Menu/menu';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true); // Estado de carga
  const [error, setError] = useState(null); // Estado de error
  const { token,logout } = useAuth();
  const [profileImage, setProfileImage] = useState(usuario);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await fetch('https://z3tr309yf9.execute-api.us-east-1.amazonaws.com/get-user', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setProfileData(data);
        } else {
          throw new Error('Error al obtener los datos del perfil.');
        }
      } catch (error) {
        console.error('Error fetching profile data:', error);
        setError('Error al cargar los datos del perfil.');
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, [token]);

  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };
  
  const handleEditProfile = () => {
    // Lógica para editar perfil
    alert("Editar Perfil");
  };
  
  const handleLogout = () => {
    logout();
    navigate('/');
  }; 
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showPopup && !event.target.closest('.popup-slide-up') && !event.target.closest('.menu-button')) {
        setShowPopup(false);
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopup]);  
  

  if (loading) {
    return <Spinner />;  // Muestra el spinner mientras los datos se cargan
  }

  if (error) {
    return <div>Error: {error}</div>; // Muestra un mensaje de error si ocurre un problema
  }

  return (
    <div className="profile-container">
      <header className="profile-header font-bold">
        <button className="three-button" onClick={togglePopup}>☰</button>
        {showPopup && (
            <div className="popup-overlay">
                <div className="popup-slide-up">
                <button className="popup-button" onClick={handleEditProfile}>Editar Perfil</button>
                <button className="popup-button logout" onClick={handleLogout}>Cerrar Sesión</button>
                <button className="popup-button cancel" onClick={togglePopup}>Cancelar</button>
                </div>
            </div>
            )}
        <h1>Mi Perfil</h1>
      </header>
      <div className="profile-content">
        <div className="profile-picture">
          <img src={profileImage} alt="Foto de perfil" />
        </div>
        <h2 className="profile-name">{profileData.name}</h2>
        <div className="profile-details">
          <p className="profile-item">
            <span className="label">Nombre:</span> 
            <span className="value">{profileData.name}</span>
          </p>
          <p className="profile-item">
            <span className="label">Apellido:</span> 
            <span className="value">{profileData.surname}</span>
          </p>
          <p className="profile-item">
            <span className="label">Cédula de identidad:</span> 
            <span className="value">{profileData.ci}</span>
          </p>
          <p className="profile-item">
            <span className="label">Email:</span> 
            <span className="value">{profileData.email}</span>
          </p>
          <p className="profile-item">
            <span className="label">Empresa:</span> 
            <span className="value">{profileData.company}</span>
          </p>
          <p className="profile-item">
            <span className="label">Salario:</span> 
            <span className="value">{profileData.salary}</span>
          </p>
          <p className="profile-item">
            <span className="label">Fecha de nacimiento:</span> 
            <span className="value">{profileData.date_of_birth}</span>
          </p>
        </div>
      </div>
      <div className="menu-container">
        <Menu />
      </div>
    </div> 
  );
};

export default Profile;

